import { render, staticRenderFns } from "./shenghuo-list.vue?vue&type=template&id=0282d5e5&scoped=true&"
import script from "./shenghuo-list.vue?vue&type=script&lang=js&"
export * from "./shenghuo-list.vue?vue&type=script&lang=js&"
import style0 from "./shenghuo-list.vue?vue&type=style&index=0&id=0282d5e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282d5e5",
  null
  
)

export default component.exports